
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle, Home, ArrowRight } from 'lucide-react';

export function DemoSuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Track demo conversion when the page loads
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17101682215/6cu0COyi9vQYEMGivJo713',
        'transaction_id': ''
      });
      console.log('[Analytics] Demo request conversion tracked');
    }
  }, []);

  return (
    <div className="min-h-screen bg-background pt-24 pb-16 px-4 flex flex-col items-center">
      <div className="container max-w-3xl mx-auto flex flex-col items-center text-center">
        <div className="mb-8 flex flex-col items-center">
          <div className="flex justify-center w-full mb-6">
            <CheckCircle className="h-24 w-24 text-green-500" />
          </div>
          <h1 className="text-3xl md:text-4xl font-semibold mb-4 text-primary">
            Thank You for Requesting a Demo!
          </h1>
          <p className="text-lg md:text-xl mb-6 text-muted-foreground">
            We've received your request and our team will contact you shortly to schedule your personalized demo.
          </p>
          <div className="bg-card rounded-lg p-6 mb-8 border border-border">
            <p className="text-md">
              In the meantime, you can explore our application by clicking "Get Started" below to create an account
              and see how our platform can transform your hiring process.
            </p>
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md justify-center">
          <Button 
            variant="outline" 
            size="lg" 
            onClick={() => navigate('/')}
            className="flex items-center gap-2"
          >
            <Home size={18} />
            Back to Home
          </Button>
          
          <Button 
            size="lg" 
            onClick={() => navigate('/signup')}
            className="flex items-center gap-2"
          >
            Get Started
            <ArrowRight size={18} />
          </Button>
        </div>
      </div>
    </div>
  );
}
